import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-16 lg:py-20">
        {/* Desktop Layout */}
        <div className="hidden lg:flex flex-col">
          <div className="flex items-center gap-10 lg:gap-16">
            {/* Left Content */}
            <div className="flex-1 w-full max-w-[540px]">
              {/* Location Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-50/70 border border-primary-200 rounded-full mb-6">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="fas fa-map-marker-alt text-primary-600 text-sm" />
                </span>
                <span className="text-sm font-medium text-primary-700">
                  Trinidad, Colorado – Reliable Transit Service
                </span>
              </div>

              {/* Heading */}
              <h1 className="font-heading text-5xl md:text-6xl lg:text-[72px] font-bold text-foreground-900 leading-[1.1] tracking-tight">
                Your ride through{" "}
                <em className="text-primary-500 font-medium">Southern Colorado</em>
              </h1>

              {/* Description */}
              <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-[480px]">
                Southern Transit connects Trinidad and surrounding communities with dependable,
                affordable public transportation – seven days a week, all year round.
              </p>
            </div>

            {/* Right Image - Desktop */}
            <div className="flex-1 w-full max-w-[600px] lg:max-w-[560px]">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                                  src="/images/h1.jpg"
                  alt="Southern Transit LLC electric transit bus in scenic mountain valley"
                  className="w-full h-auto object-cover aspect-[4/3]"
                />
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex items-center gap-4 mt-10">
            <Link
              to="/airport-shuttle"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              View Schedules
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="fas fa-arrow-right" />
              </span>
            </Link>
            <a
              href="mailto:lynn@southerntransit.us"
              className="inline-flex items-center px-8 py-4 border-2 border-primary-500 text-primary-600 text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="flex flex-col lg:hidden items-center text-center">
          {/* Location Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-50/70 border border-primary-200 rounded-full mb-5">
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="fas fa-map-marker-alt text-primary-600 text-sm" />
            </span>
            <span className="text-sm font-medium text-primary-700">
              Trinidad, Colorado – Reliable Transit Service
            </span>
          </div>

          {/* Heading */}
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-foreground-900 leading-[1.1] tracking-tight">
            Your ride through{" "}
            <em className="text-primary-500 font-medium">Southern Colorado</em>
          </h1>

          {/* Mobile Hero Image */}
          <div className="mt-6 w-full max-w-[500px]">
            <div className="rounded-2xl overflow-hidden">
              <img
                              src="/images/h1.jpg"
                alt="Southern Transit LLC electric transit bus"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Description */}
          <p className="mt-6 text-base text-foreground-600 leading-relaxed max-w-[480px]">
            Southern Transit connects Trinidad and surrounding communities with dependable,
            affordable public transportation – seven days a week, all year round.
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/airport-shuttle"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              View Schedules
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="fas fa-arrow-right" />
              </span>
            </Link>
            <a
              href="mailto:lynn@southerntransit.us"
              className="inline-flex items-center px-7 py-3.5 border-2 border-primary-500 text-primary-600 text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}